module.exports = {
      id: "form-usage",
      viewBox: "0 0 18 22",
      url: __webpack_public_path__ + "sprite-d2a4e8aaeb47684d6d07571fc646b0db.svg#form",
      toString: function () {
        return this.url;
      }
    }